export const joberTitles = [
    "",
    "Nombre",
    "Teléfono",
    "Nº Reviews",
    "Puntuación",
    "Créditos",
    "Nº de compras",
    "Última conexión",
    "Fecha registro",
    "Compra PCs",
    "Mensajes",
    "Business"
];

export const joberTitlesConstructora = [
    "",
    "Nombre",
    "Teléfono",
    "Nº Reviews",
    "Puntuación",
    "Nº trabajos",
    "Última conexión",
    "Fecha registro",
    "Business"
];

export const goldJoberTitles = [
    "",
    "Nombre",
    "Teléfono",
    "Nº Reviews",
    "Puntuación",
    "Créditos",
    "Nº de compras",
    "Última conexión",
    "Fecha registro",
    "Business"
];

export const clientTitles = [
    "",
    "Nombre",
    "Teléfono",
    "Última conexión",
    "Fecha registro"
];

